import { formatterPrice } from 'src/utils/formatterPrice'
import { MapPinIcon } from 'src/components/Icons/MapPinIcon'
import { useProductPageContext } from 'src/components/restructure/product/contexts'
import { FulfilledIcon } from 'src/components/Icons/FulfilledIcon'
import { CalendarIcon } from 'src/components/Icons/CalendarIcon'

import {
  ExpressShippingBadge,
  FreeShippingBadge,
} from '../components/ShippingBadges'
import type { FreightPickupPoint } from '../useFreightSimulation'

export const PickupPointCard = ({
  name,
  distance,
  address,
  shippingEstimate,
  price,
  handleCloseModal,
}: FreightPickupPoint & { handleCloseModal: () => void }) => {
  const { selectedPickupPoint, setSelectedPickupPoint } =
    useProductPageContext()

  const { street, number, neighborhood } = address
  const isExpressShipping = shippingEstimate === '2h'
  const isSelected = selectedPickupPoint?.name === name

  const handleSelectPickupPoint = () => {
    if (isSelected) {
      return
    }

    setSelectedPickupPoint({
      name,
      distance,
      address,
      shippingEstimate,
      price,
    })

    handleCloseModal()
  }

  const shippingEstimateFormatted = shippingEstimate.trim().endsWith('bd')
    ? shippingEstimate.trim().slice(0, -2).trim()
    : shippingEstimate

  return (
    <li
      className={`pickupModalCard mb-4 cursor-pointer ${
        isSelected
          ? 'pickupModalCardActive border rounded-sm border-primaryBlue '
          : 'border-b border-gray'
      }`}
    >
      <button
        onClick={handleSelectPickupPoint}
        className={`w-full flex flex-col gap-4 p-2 ${
          isSelected ? 'py-3' : 'pb-6'
        }`}
      >
        <div className="flex justify-between items-start">
          <p className="text-sm text-left leading-[21px] font-semibold text-restructure-primary">
            {name}
          </p>
          <div className="flex items-center gap-1">
            {price === 0 ? (
              <FreeShippingBadge />
            ) : (
              <p className="text-sm leading-[21px] font-semibold text-primaryBlue">
                {formatterPrice(price / 100)}
              </p>
            )}
            {isExpressShipping && <ExpressShippingBadge />}
          </div>
        </div>
        <div className="flex flex-col gap-[2px]">
          {isExpressShipping && (
            <div className="flex items-center">
              <FulfilledIcon />
              <p className="text-font-size-2 text-tertiary">
                Em estoque na loja
              </p>
            </div>
          )}
          <div className="flex items-center gap-2">
            <CalendarIcon />
            <p className="text-font-size-2 text-tertiary">
              Disponível após{' '}
              {isExpressShipping
                ? '2h do pagamento'
                : `${shippingEstimateFormatted} dias úteis`}
            </p>
          </div>
        </div>
        <div className="flex justify-between items-center">
          <p className="text-font-size-1 text-tertiary">
            {street}, {number} - {neighborhood}
          </p>
          <div className="flex gap-1 items-center">
            <MapPinIcon />
            <p className="text-font-size-2 font-semibold text-tertiary">
              {distance}
            </p>
          </div>
        </div>
      </button>
    </li>
  )
}
